import { miscUiState } from './globalState';
const qsParams = new URLSearchParams(window.location?.search ?? '');
globalThis.process ??= {};
const initialAppConfig = process?.env?.INLINED_APP_CONFIG ?? {};
export const appQueryParams = new Proxy({}, {
    get(target, property) {
        if (typeof property !== 'string') {
            return undefined;
        }
        const qsParam = qsParams.get(property);
        if (qsParam)
            return qsParam;
        return miscUiState.appConfig?.appParams?.[property];
    },
});
export const appQueryParamsArray = new Proxy({}, {
    get(target, property) {
        if (typeof property !== 'string') {
            return null;
        }
        const qsParam = qsParams.getAll(property);
        if (qsParam.length)
            return qsParam;
        return miscUiState.appConfig?.appParams?.[property] ?? [];
    },
});
export function updateQsParam(name, value) {
    const url = new URL(window.location.href);
    if (value) {
        url.searchParams.set(name, value);
    }
    else {
        url.searchParams.delete(name);
    }
    window.history.replaceState({}, '', url.toString());
}
// Helper function to check if a specific query parameter exists
export const hasQueryParam = (param) => qsParams.has(param);
// Helper function to get all query parameters as a URLSearchParams object
export const getRawQueryParams = () => qsParams;
globalThis.debugQueryParams = Object.fromEntries(qsParams.entries());
